import type { UsePriceDisplayReturn } from '@terminal/react-query-hooks/prices/usePriceDisplay';

type Price = NonNullable<UsePriceDisplayReturn['priceData']>['price'];

export const getPriceChange = (price: Price, isWindowComplete?: boolean) => {
  const { marketHours } = price.primary;
  const liveSecondaryPriceChange =
    price.secondary?.price !== undefined &&
    price.secondary?.isLive &&
    price.secondary.priceChange;

  if (
    !isWindowComplete &&
    (marketHours.isPreMarket || marketHours.isAfterMarket) &&
    liveSecondaryPriceChange
  ) {
    return liveSecondaryPriceChange;
  }

  return price.primary.priceChange;
};
